import {
  type Action,
  TrackObject,
  type UserJourney,
  useAnalyticsTracker,
} from "./AnalyticsProvider";

export enum RewardsScreen {
  QUEST_FILTER = "QuestFilter",
  PROGRESS_BAR = "ProgressBar",
  ONBOARDING_PROGRESS_BAR = "OnboardingProgressBar",
  REWARDS_HISTORY = "RewardsHistory",
  WEEKLY_REWARDS = "WeeklyRewards",
  USER_ACTIVITIES = "UserActivities",
}

// Base properties for any Rewards event
interface BaseRewardsExtras extends Record<string, unknown> {
  screen: RewardsScreen;
  userJourney: UserJourney;
  section?: string;
}

// Specific event types discriminated by action
export type RewardsEvent =
  | {
      action: Action.OPENED;
      extras: BaseRewardsExtras & {
        section: string;
        // Progress bar specific properties (optional)
        totalQuestsCompleted?: number;
        currentRarity?: string;
        progressPercentage?: number;
        // Modal specific properties (optional)
        questName?: string;
        ticketStatus?: string;
        rarity?: string;
        ticketId?: string;
      };
    }
  | {
      action: Action.PRESSED;
      extras: BaseRewardsExtras & {
        gameName?: string;
        questName?: string;
        gameId?: string;
        externalId?: string;
        activityTitle?: string;
      };
    }
  | {
      action: Action.VIEWED;
      extras: BaseRewardsExtras;
    }
  | {
      action: Action.COMPLETED;
      extras: BaseRewardsExtras & {
        questName?: string;
        rewardAmount?: number;
        gameId?: string;
      };
    };

export const useRewardsAnalytics = () =>
  useAnalyticsTracker<RewardsEvent>(TrackObject.REWARDS);
